import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Gym, GymType } from 'src/app/model/gym';
import { StudioType } from 'src/app/model/studio-type';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'gymfinder-basic-info',
  templateUrl: './basic-info.component.html',
  styleUrls: ['./basic-info.component.scss'],
  standalone: false,
})
export class BasicInfoComponent implements OnInit {
  @Input()
  editMode: boolean;

  @Input()
  studioTypes: StudioType[];

  @Input()
  gymTypes: string[];

  @Input()
  gym: Gym;

  @Input()
  displayGymlibBackOfficeLink: boolean;

  @Output()
  gymChange = new EventEmitter<Gym>();

  public gymlibBackOfficeUrl: string;

  ngOnInit() {
    this.gymlibBackOfficeUrl = this.getGymlibBackOfficeUrl();
    this.displayGymlibBackOfficeLink =
      this.gym.options?.gymTypes?.includes(GymType.WELLPASS_FR_BE_CREDITS) ||
      this.gym.options?.gymTypes?.includes(GymType.WELLPASS_FR_BE_UNLIMITED);
  }

  private getGymlibBackOfficeUrl(): string {
    return `${environment.gymlibBackOfficeUrl}/index.html#/Gym/${this.gym.slug}`;
  }

  public get alias(): string | undefined {
    return this.gym.alias;
  }

  public set alias(value: string | undefined) {
    this.gym.alias = value;
    this.gymChange.emit(this.gym);
  }

  public get studioType(): string | undefined {
    return this.gym.studioType;
  }

  public set studioType(value: string | undefined) {
    this.gym.studioType = value;
    this.gymChange.emit(this.gym);
  }

  public get profilePagePublic(): boolean {
    return this.gym.profilePagePublic;
  }

  public set profilePagePublic(value: boolean) {
    this.gym.profilePagePublic = value;
    this.gymChange.emit(this.gym);
  }

  public get visibleInBusinessSuite(): boolean {
    return this.gym.visibleInBusinessSuite;
  }

  public set visibleInBusinessSuite(value: boolean) {
    this.gym.visibleInBusinessSuite = value;
    this.gymChange.emit(this.gym);
  }

  public get disableStudioPageEditing(): boolean {
    return this.gym.disableStudioPageEditing;
  }

  public set disableStudioPageEditing(value: boolean) {
    this.gym.disableStudioPageEditing = value;
    this.gymChange.emit(this.gym);
  }
}
